import { useSelector } from 'react-redux';
import { elevatorCoordinatesSelector } from '../services/selectors';

export const useElevatorCoordinates = () => useSelector(elevatorCoordinatesSelector);
